import React, {useState} from 'react';
import Col from 'reactstrap/lib/Col';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import {Toast} from '../../utils/sweetAlert';
import {t} from 'react-switch-lang';
import axios from 'axios';
import Logo from './img/logoRms.svg';
import Label from 'reactstrap/lib/Label';
import InputText from '../../components/FormFields/InputText';
import {useHistory} from 'react-router-dom';
import * as yup from 'yup';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import Eye from './img/eye.svg';
import EyeOff from './img/eye-off.svg';
import Swal from 'sweetalert2';

const ResetPassword = () => {
  const history = useHistory();
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShownRepeat, setPasswordShownRepeat] = useState(false);

  const passwordScheme = yup.object().shape({
      password: yup
        .string()
        .required(t('message.fieldRequired'))
        .min(8, t('message.min', {min: 8}))
        .max(20, t('message.max', {max: 20})),
      newPassword: yup
        .string()
        .required(t('message.fieldRequired'))
        .min(8, t('message.min', {min: 8}))
        .max(20, t('message.max', {max: 20}))
        .test(
          'passwords-match',
          t('message.passwordMatch'),
          function(value) {
            return this.parent.password === value;
          },
        ),
    },
    ['password', 'newPassword'],
  );
  const methods = useForm({
    resolver: yupResolver(passwordScheme),
  });
  const {handleSubmit, errors} = methods;
  const submitForm = async (data, e) => {
    e.preventDefault();
    const key = new URLSearchParams(history.location.search).get('key');
    const formBody = {
      key: key,
      newPassword: data.password,
    };
    axios({
      method: 'POST',
      url: `/account/reset-password/finish`,
      data: JSON.stringify(formBody),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((r) => {
        if (r?.status === 200) {
          Toast.fire({
            title: t('message.passwordChanged'),
            icon: 'success',
          });
        history.push(`/login`);
        }
      })
      .catch((r) => {
        if (r.response.data.code === 'password-reset') {
          Swal.fire({
            text: t('message.passwordReset'),
            icon: 'error',
          });
        }
      });
  };
  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };

  const togglePasswordVisibilityRepeat = () => {
    setPasswordShownRepeat(!passwordShownRepeat);
  };
  return (
    <div className='login_wrapp'>
      {/*<div className='left'></div>*/}
      <div className='right'>
        <Container>
          <div className='wrapp'>
            <img className='header-img' src={Logo}></img>
            <h4 className='login-title'></h4>
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(submitForm)}>
                <div className={'div-position-relative'}>
                  <Row className='mb-4'>
                    <Label for='mail'> {t('login.newPassword')}</Label>
                    <InputText
                      name={'password'}
                      type={passwordShown ? 'text' : 'password'}
                      id='password'
                      className={
                        'form-control ' +
                        (errors.password !== undefined ? 'error-field' : '')
                      }
                      placeholder={t('login.passwordPlaceholder')}
                    />
                    <img
                      src={passwordShown ? EyeOff : Eye}
                      alt='password_show'
                      className='show_hisde'
                      onClick={togglePasswordVisibility}
                    />
                  </Row>
                </div>
                <div className={'div-position-relative'}>
                <Row className='mb-4'>
                    <Label for='newPassword'> {t('login.repeatPassword')}</Label>
                    <InputText
                      name={'newPassword'}
                      type={passwordShownRepeat ? 'text' : 'password'}
                      id='newPassword'
                      className={
                        'form-control ' +
                        (errors.newPassword !== undefined ? 'error-field' : '')
                      }
                      placeholder={t('login.passwordPlaceholder')}
                    />
                    <img
                      src={passwordShownRepeat ? EyeOff : Eye}
                      alt='password_show'
                      className='show_hide'
                      onClick={togglePasswordVisibilityRepeat}
                    />
                  </Row>
                </div>
                <Row className='submit-buttons-container mx-0'>
                  <Col sm={12} className='text-right px-0'>
                    <div className='submit d-flex justify-content-center'>
                      <button className='primary'>
                        {t('buttons.confirm')}
                      </button>
                    </div>
                  </Col>
                </Row>
              </form>
            </FormProvider>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default ResetPassword;
